<template>
  <div class="page">
    <div class="goodscon">
      <div class="titlecon" v-if="inspectionDetail">
        <div class="titleleft">
          <span>编号: {{ inspectionDetail.inOrderNo }}</span>
          <span v-if="inspectionDetail.add_user"
            >分拨人: {{ inspectionDetail.add_user.user_name }}</span
          >
          <span>调拨来源: {{ inspectionDetail.otherShopName }}</span>
          <span>调拨人: {{ inspectionDetail.inUserName }}</span>
          <span
            >调拨日期:
            {{ $public.FTime(inspectionDetail.inDate, "YYYY-MM-DD") }}</span
          >
          <span>调拨数量: {{ distributionCount }}</span>
          <span>调拨备注: {{ inspectionDetail.remark }}</span>
          <div>
            <span>验收人: {{ inspectionDetail.approveUserName }}</span>
            <span
              >验收日期:
              {{
                $public.FTime(inspectionDetail.approveDate, "YYYY-MM-DD")
              }}</span
            >
            <span
              >状态:<span
                style="color: #e6a23c"
                v-if="inspectionDetail.acceptStatus == 0"
                >未验收</span
              >
              <span
                style="color: #13ce66"
                v-if="inspectionDetail.acceptStatus == 1"
                >部分验收
              </span>
              <span
                style="color: #ff4d51"
                v-if="inspectionDetail.acceptStatus == 2"
                >已验收
              </span></span
            >
            <span
              >实收数量:
              <strong style="color: red">{{ distributionTotalCount }}</strong>
            </span>
          </div>
        </div>
        <div class="titleright">
          <el-button type="warning" @click="isBack()" size="small"
            >返回</el-button
          >
        </div>
      </div>
      <div>
        录入条码：
        <input
          class="el-input__inner"
          type="text"
          style="width: 260px"
          placeholder="商品条码"
          v-model.lazy="goodsCustomCode"
          @keyup.enter="search"
        />
      </div>
      <div style="margin-top: 10px">
        <el-table
          default-expand-all
          row-class-name="row-expand-cove"
          show-summary
          :data="sumData"
          style="width: 100%"
        >
          <el-table-column label="商品名称">
            <template slot-scope="scope">
              <span>{{ scope.row.goodsName }}</span>
            </template>
          </el-table-column>

          <el-table-column label="规格">
            <template slot-scope="scope">
              <span>{{ scope.row.skuValue }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单位">
            <template slot-scope="scope">
              <span>{{ scope.row.unit }}</span>
            </template>
          </el-table-column>
          <el-table-column label="验收状态" width="180px">
            <template slot-scope="scope">
              <span v-if="scope.row.count == scope.row.acceptCount">
                <span style="color: #13ce66">•</span>
                已验收 {{ scope.row.acceptCount }} / {{ scope.row.count }}
              </span>
              <span
                v-if="
                  scope.row.count > scope.row.acceptCount &&
                  scope.row.acceptCount != 0
                "
              >
                <span style="color: #e6a23c">•</span>
                部分验收 {{ scope.row.acceptCount }} / {{ scope.row.count }}
              </span>
              <span v-if="scope.row.acceptCount == 0">
                <span style="color: #e6a23c">•</span>
                未验收 {{ scope.row.acceptCount }} / {{ scope.row.count }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150px">
            <template slot-scope="scope">
              <el-button type="text" @click="toogleExpand(scope.row)">
                查看条码
              </el-button>
            </template>
          </el-table-column>

          <el-table-column type="expand" width="1">
            <template slot-scope="props">
              <div class="goodscustom">
                <div>条码数量 {{ props.row.goodsItem.length }}</div>

                <div style="margin-top: 10px">
                  <span
                    v-for="(goodscustom, subindex) in props.row.goodsItem"
                    :key="subindex"
                  >
                    <el-tag
                      :closable="goodscustom.totaTimes !== 1 ? false : true"
                      style="margin: 5px"
                      :type="getType(goodscustom)"
                      @close="handleClose(goodscustom)"
                    >
                      {{ goodscustom.customCode }} 总次数:{{
                        goodscustom.totaTimes
                      }}
                      已用次数:{{ goodscustom.useTimes }}
                    </el-tag>
                  </span>
                </div>
                <!-- <div style="margin: 10px;color: #000;" v-else>
									暂无条码数据
								</div> -->
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-form :model="inspectionDetail" style="margin-top: 20px">
        <el-form-item label="验收备注" label-width="80px">
          <el-input
            style="width: 300px"
            type="textarea"
            :rows="3"
            placeholder="请输入内容"
            v-model="inspectionDetail.approveRemark"
          >
          </el-input>
        </el-form-item>
      </el-form>

      <div class="footer">
        <div></div>
        <div>
          <span style="margin-right: 10px"
            >验货数量
            <strong style="color: #ff0000">{{ distributionTotalCount }}</strong>
          </span>
          <!-- <el-button class="desc"  type="primary" @click='saveAcceptance'>保存</el-button> -->
          <el-button
            class="desc"
            type="warning"
            @click="allCancel"
            v-if="canCancelList.length"
            >全部退回</el-button
          >
          <el-button
            class="desc"
            type="warning"
            @click="Cancel"
            v-if="canCancelList.length"
            >条码退回</el-button
          >
          <el-button
            class="desc"
            :loading="loading"
            type="primary"
            @click="submiAcceptance"
            >验货入库</el-button
          >
        </div>
      </div>
    </div>
    <el-dialog title="提示" center :visible.sync="dialogVisibleAll" width="20%">
      <div style="text-align: center">是否将未验货的条码全部退回?</div>
      <div style="margin: 15px 0px">退回备注</div>
      <el-input type="textarea" placeholder="请输入内容" v-model="remarkAll">
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleAll = false">取消</el-button>
        <el-button type="warning" @click="sumbitCancelAll">确认退回</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="退回条码"
      center
      :visible.sync="dialogVisibleCancel"
      width="40%"
    >
      <div>已选择条码数:{{ selectCodeList.length }}</div>
      <div style="display: flex; margin-top: 10px">
        <div
          :class="item.isActive ? 'code_item_active' : 'code_item'"
          v-for="item in canCancelList"
          :key="item.id"
        >
          <span @click="changeCode(item)"> {{ item.customCode }}</span>
        </div>
      </div>
      <div style="margin: 15px 0px">退回备注</div>
      <el-input
        type="textarea"
        style="width: 300px"
        placeholder="请输入内容"
        v-model="remark"
      >
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleCancel = false">取消</el-button>
        <el-button type="warning" @click="sumbitCancel">确认退回</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getShopInOrderDl,
  getGoodsCodeInfo,
  setShopInOrder,
} from "@/api/stockApi.js";
export default {
  data() {
    return {
      codeList: [], //录入条码
      // 可退回条码数组
      canCancelList: [],
      remark: "", //部分退出
      remarkAll: "", //备注
      dialogVisibleAll: false,
      dialogVisibleCancel: false,
      goodsCustomCode: "",
      showType: {
        showType1: true,
        showType2: true,
      },
      dialogVisible: false,
      sumData: [],
      inspectionDetail: {
        inOrderItems: [],
      },
      acceptanceParam: {
        code_list: [],
      },
      acceptItem: "",
      acceptdetail: "",
      loading: false,
    };
  },
  computed: {
    // 全部退回
    allCodeList() {
      let arr = [];
      this.canCancelList.forEach((item) => {
        arr.push(item.customCode);
      });
      return arr;
    },
    // 计算选择退回条码数量
    selectCodeList() {
      let arr = [];
      this.canCancelList.forEach((item) => {
        if (item.isActive == true) {
          arr.push(item.customCode);
        }
      });
      return arr;
    },
    //计算各商品分拨总数量
    distributionCount() {
      let distributionCount = 0;
      this.inspectionDetail.inOrderItems.forEach((item) => {
        distributionCount += item.count;
      });
      return distributionCount;
    },
    // 计算分拨总数量
    distributionTotalCount() {
      let _distributionTotalCount = 0;
      this.inspectionDetail.inOrderItems.forEach((item) => {
        _distributionTotalCount += item.acceptCount;
      });

      return _distributionTotalCount;
    },
  },
  methods: {
    // 选择条码退回
    changeCode(item) {
      console.log(item);
      this.$set(item, "isActive", !item.isActive);
    },
    getType(goodscustom) {
      if (goodscustom.isCancel == 1) {
        return "warning";
      }
      if (goodscustom.acceptCount !== 0) {
        return "success";
      }
      if (goodscustom.acceptCount == 0) {
        return "info";
      }
    },
    // 条码部分退回
    Cancel() {
      this.dialogVisibleCancel = true;
    },
    // 提交全部退回
    sumbitCancelAll() {
      let type = 2;
      this.inCancel(type, this.remark);
    },
    // 部分退回
    sumbitCancel() {
      let type = 1;
      this.inCancel(type, this.remark);
    },
    // 退回条码
    inCancel(type = 1, remark = "") {
      if (type == 1 && !this.selectCodeList.length) {
        this.$message({
          type: "error",
          message: "请选择要退回的条码",
        });
        return;
      }
      let params = {
        inOrderId: this.inspectionDetail.id, //出库单号
        customCodes: type == 1 ? this.selectCodeList : this.allCodeList, //对应条码
        remark: remark,
      };
      this.$http
        .post(process.env.VUE_APP_Url3 + "api/shop/transfer/in/Cancel", params)
        .then((res) => {
          // loading.close();
          if (res.code == 0) {
            if (type == 1) {
              this.dialogVisibleCancel = false;
            } else {
              this.dialogVisibleAll = false;
            }
            this.$router.go(0);
          }
        });
    },

    // 退回条码(全部退回)
    allCancel() {
      this.dialogVisibleAll = true;
    },
    fillterGoodsCustom(arry) {
      let custtomList = arry.filter((item) => {
        return item.is_check == true || item.goods_state == 4;
      });

      return custtomList;
    },
    getShopInOrderDl(id) {
      this.acceptanceParam.code_list = [];
      getShopInOrderDl({
        orderId: id,
      }).then((res) => {
        if (res.code == 0) {
          this.inspectionDetail = res.data;
          this.inspectionDetail.inOrderItems.forEach((item) => {
            if (item.acceptCount !== 1 && item.isCancel !== 1) {
              this.$set(item, "isActive", false);
              this.canCancelList.push(item);
            }
          });
          this.sumData = this.sumGoods(res.data.inOrderItems);
          // canCancelList
          res.data.inOrderItems.forEach((item) => {
            if (item.acceptCount == item.count) {
              this.acceptanceParam.code_list.push(item.customCode);
            }
          });
          console.log(
            this.sumData,
            this.inspectionDetail,
            "====",
            this.canCancelList
          );
        }
      });
    },
    sumGoods(arry) {
      let sumData = [];
      arry.forEach((item) => {
        let index = sumData.findIndex((ele) => {
          return item.goodsId == ele.goodsId && item.skus == ele.skus;
        });

        if (index == -1) {
          sumData.push({
            goodsId: item.goodsId,
            goodsName: item.goodsName,
            count: item.count,
            acceptCount: item.acceptCount,
            skus: item.skus,
            skuValue: item.skuValue,
            unit: item.unit,
            goodsItem: [item],
          });
        } else {
          sumData[index].acceptCount += item.acceptCount;
          sumData[index].count += item.count;
          sumData[index].goodsItem.push(item);
        }
      });
      return sumData;
    },
    submiAcceptance() {
      console.log(this.codeList);
      // this.acceptanceParam.code_list.length == 0
      if (this.codeList == 0) {
        this.$message({
          type: "info",
          message: "请录入条码进行验货",
        });
      } else {
        this.loading = true;
        this.$confirm(
          "请确保商品和条码一致，验货完成，操作后将无法继续验货?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            // var params = Object.assign({}, this.inspectionDetail);
            // if (this.distributionTotalCount === this.distributionCount) {
            //   params.acceptStatus = 2;
            // } else {
            //   params.acceptStatus = 1;
            // }
            // params.inOrderItems = [];
            // this.sumData.forEach((item) => {
            //   params.inOrderItems.push(...item.goodsItem);
            // });
            let params = {
              inOrderId: this.inspectionDetail.id,
              lstCodes: this.acceptanceParam.code_list,
            };
            console.log(params, "this.inspectionDetail");
            let loading = this.$loading();
            setShopInOrder(params).then((res) => {
              loading.close();
              if (res.code == 0) {
                console.log(res);
                this.$message({
                  type: "info",
                  message: "验货成功",
                });
                this.loading = false;
                this.$router.push({
                  path: "/ruku/rukuList",
                });
              }
            });

            // this.$message({
            //   type: 'success',
            //   message: '删除成功!'
            // });
          })
          .catch(() => {
            this.loading = false;
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    handleShopClick(type) {
      this.showType["showType" + type] = !this.showType["showType" + type];
    },
    toogleExpand(row) {
      let $table = this.$refs["table" + row.goods.goods_type][0];
      $table.toggleRowExpansion(row);
    },
    search() {
      let params = {
        customCode: this.goodsCustomCode,
      };
      let loading = this.$loading();
      getGoodsCodeInfo(params).then((res) => {
        console.log(res, "res");
        loading.close();
        if (res.code == 0) {
          // let isFound = false;
          let isRepeat;
          // let isacept = false;
          //判断是否重复
          isRepeat = this.acceptanceParam.code_list.some((item) => {
            return item == res.data.customCode;
          });

          if (isRepeat) {
            this.$message.error("条码重复");
            this.goodsCustomCode = "";
          } else {
            //判断是否找到
            this.sumData.forEach((item) => {
              item.goodsItem.forEach((ele) => {
                if (
                  ele.customCode == res.data.customCode &&
                  ele.acceptCount != ele.count
                ) {
                  ele.acceptCount = ele.count;
                  ele.totaTimes = res.data.totaTimes;
                  ele.useTimes = res.data.useTimes;
                  item.acceptCount += ele.acceptCount;
                  this.codeList.push(res.data.customCode);
                  this.acceptanceParam.code_list.push(res.data.customCode);
                  return;
                }
              });
            });
            this.goodsCustomCode = "";
            // if (isacept) {
            // 	this.$message.error('此条码已验货');
            // 	this.goodsCustomCode = "";
            // }
            // if (!isFound) {
            // 	this.$message.error('该验货单中未匹配到此条码,就是说这个验货单中没有分配给你这个条码，要么你扫错商品了，要么送错了,' + '此条码状态为' + res.data.data.customCodeStatus
            // 		.name);
            // 	this.goodsCustomCode = "";
            // }
          }
        }
      });
    },

    isBack() {
      this.$alert("你正在验货,返回数据将不会保存,确认返回", "确认返回", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            this.$router.push({
              path: "/ruku/rukuList",
              query: {
                tabs: 2,
              },
            });
          } else {
            this.$message({
              type: "info",
              message: "取消返回",
            });
          }
        },
      });
    },
    handleClose(goodscustom) {
      //删除提交的条码数据 隐藏条码验收状态，并改变验货实收数量
      let index = this.acceptanceParam.code_list.indexOf(
        goodscustom.customCode.toString()
      );
      let index1 = this.codeList.indexOf(goodscustom.customCode.toString());
      this.acceptanceParam.code_list.splice(index, 1);
      this.codeList.splice(index1, 1);
      this.sumData.forEach((item) => {
        item.goodsItem.forEach((ele) => {
          if (
            goodscustom.goodsId == ele.goodsId &&
            goodscustom.skus == ele.skus
          ) {
            item.acceptCount -= ele.acceptCount;
            goodscustom.totaTimes = 0;
            goodscustom.acceptCount = 0;
            return;
          }
        });
      });
    },

    saveAcceptance() {
      if (this.acceptanceParam.code_list.length == 0) {
        this.$message({
          type: "info",
          message: "请录入条码进行验货",
        });
      } else {
        var params = Object.assign({}, this.inspectionDetail);
        if (this.distributionTotalCount == this.distributionCount) {
          params.acceptStatus = 2;
        } else {
          params.acceptStatus = 1;
        }
        params.inOrderItems = [];
        this.sumData.forEach((item) => {
          params.inOrderItems.push(...item.goodsItem);
        });

        setShopInOrder(params).then((res) => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "保存成功",
            });

            this.$router.push({
              path: "/ruku/rukuList",
            });
          }
        });
      }
    },
  },
  created() {
    this.getShopInOrderDl(this.$route.query.id);
  },
};
</script>

<style lang="scss">
.code_item {
  margin-right: 10px;
  color: #9d9d9d;
  border: 1px solid #9d9d9d;
  background: #f4f4f4;
  border-radius: 4px;
  border: 1px solid #9d9d9d;
  padding: 10px;
}
.code_item_active {
  padding: 10px;
  margin-right: 10px;
  background: #dbffe8;
  border-radius: 4px;
  color: #11b44b;
  border: 1px solid #11b44b;
}
.titlecon {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  background-color: #fff;
  margin-bottom: 10px;
  padding: 10px 0px;

  .titleleft {
    span {
      margin: 5px 20px;
      display: inline-block;
    }
  }

  .titleright {
    margin-right: 20px;
    // margin-top: 20px;
  }
}

.comH2 {
  line-height: 64px;
  font-size: 18px;
  display: flex;
  align-items: center;
}

.abnormalpopover {
  background-color: #000000;
  color: #fff;
}

.row-expand-cove .el-table__expand-icon {
  display: none;
}

.footer {
  background-color: #f5f5f5;
  position: fixed;
  bottom: 0;
  height: 50px;
  line-height: 50px;
  display: flex;
  justify-content: space-between;
  left: 220px;
  right: 0;
  padding-left: 20px;
  z-index: 200;

  .desc {
    margin-right: 20px;
  }
}
</style>
